//main

import { createApp } from "vue";
import router from "./router.js";
import vuetify from "./plugins/vuetify.js";
import App from "./App.vue";
import 'vuetify/styles';


const app = createApp(App);
app.use(vuetify);

app.use(router);

app.mount("#app");
